import * as actionTypes from './actionTypes';
import { createActionObject, getAjaxFunc } from '../../helpers/common';

import * as api from '../api';

export const callPortfolioFaultTotalize = (payload) => async (dispatch) => {
    try {
      const response = await api.portfolioFaultTotalize(payload);
      if (response.status === 200 && response.data) {
        dispatch({
          type: actionTypes.GET_PORTFOLIO_FAULT_TOTALIZE_DATA,
          payload: response.data  
        });
      } else {
        dispatch({
          type: actionTypes.GET_PORTFOLIO_FAULT_TOTALIZE_FAILURE,
          payload: {} // Instead of null, set an empty object
        });
      }
    } catch (error) {
      dispatch({
        type: actionTypes.GET_PORTFOLIO_FAULT_TOTALIZE_FAILURE,
        payload: { error: error.message }
      });
    }
};

export const setSelectedPortfolioFaultCompany = selectedPortfolioFaultCompany => dispatch => dispatch(
    createActionObject(
      actionTypes.SET_SELECTED_PORTFOLIO_FAULT_COMPANY,
      { selectedPortfolioFaultCompany }
    )
);

export const setSelectedPortfolioFaultCity = selectedPortfolioFaultCity => dispatch => dispatch(
    createActionObject(
      actionTypes.SET_SELECTED_PORTFOLIO_FAULT_CITY,
      { selectedPortfolioFaultCity }
    )
);
  
export const setSelectedPortfolioFaultCountry = selectedPortfolioFaultCountry => dispatch => dispatch(
    createActionObject(
      actionTypes.SET_SELECTED_PORTFOLIO_FAULT_COUNTRY,
      { selectedPortfolioFaultCountry }
    )
);
  
export const setSelectedPortfolioFaultProject = selectedPortfolioFaultProject => dispatch => dispatch(
    createActionObject(
        actionTypes.SET_SELECTED_PORTFOLIO_FAULT_PROJECT,
        { selectedPortfolioFaultProject }
    )
);

export const setSelectedPortfolioFaultYear = selectedPortfolioFaultYear => dispatch => dispatch(
    createActionObject(
        actionTypes.SET_SELECTED_PORTFOLIO_FAULT_YEAR,
        { selectedPortfolioFaultYear }
    )
);

export const setSelectedPortfolioFaultMonth = selectedPortfolioFaultMonth => dispatch => dispatch(
    createActionObject(
        actionTypes.SET_SELECTED_PORTFOLIO_FAULT_MONTH,
        { selectedPortfolioFaultMonth }
    )
);

export const setSelectedPortfolioFaultDay = selectedPortfolioFaultDay => dispatch => dispatch(
    createActionObject(
        actionTypes.SET_SELECTED_PORTFOLIO_FAULT_DAY,
        { selectedPortfolioFaultDay }
    )
);

export const setSelectedPortfolioFaultStations = selectedPortfolioFaultStation => dispatch => dispatch(
    createActionObject(
        actionTypes.SET_SELECTED_PORTFOLIO_FAULT_STATIONS,
        { selectedPortfolioFaultStation }
    )
);

export const setSelectedPortfolioFaultDisplayMode = selectedPortfolioFaultDisplayMode => dispatch => dispatch(
    createActionObject(
      actionTypes.SET_SELECTED_PORTFOLIO_FAULT_DISPLAY_MODE,
      { selectedPortfolioFaultDisplayMode }
    )
);

// Set Selected Portfolio Fault Level
export const setSelectedPortfolioFaultLevel = (selectedPortfolioFaultLevel) => (dispatch) =>
    dispatch({
      type: actionTypes.SET_SELECTED_PORTFOLIO_FAULT_LEVEL,
      selectedPortfolioFaultLevel,
});

// Reset Selected Portfolio Fault Level
export const resetSelectedPortfolioFaultLevel = () => (dispatch) =>
    dispatch({
        type: actionTypes.RESET_SELECTED_PORTFOLIO_FAULT_LEVEL,
});

// Fetch Portfolio Fault Levels and Set Default to 'Country'
export const callPortfolioFaultLevels = () => async (dispatch) => {
    dispatch({ type: actionTypes.FETCH_PORTFOLIO_FAULT_LEVELS_REQUEST });
    try {
      const response = await api.getPortfolioFaultLevel();
      const data = response.data;

      dispatch({
        type: actionTypes.FETCH_PORTFOLIO_FAULT_LEVELS_SUCCESS,
        payload: data,
      });
  
      // Set 'Country' as default selection if available
      const defaultLevel = data.find(
        (level) => level.portfolioSelection.toLowerCase() === "country"
      );
      if (defaultLevel) {
        dispatch(setSelectedPortfolioFaultLevel(defaultLevel.portfolioSelection));
      }
    } catch (error) {
      dispatch({
        type: actionTypes.FETCH_PORTFOLIO_FAULT_LEVELS_FAILURE,
        error: error.message,
      });
    }
};

export const callPortfolioFaultDetails = (payload) => (dispatch) => {
    dispatch({ type: actionTypes.GET_PORTFOLIO_FAULT_DETAILS_REQUEST });

    api.getPortfolioFaultDetails(payload)
        .then(({ data, status }) => {
        if (status === 200) {
            dispatch(
            createActionObject(
                actionTypes.GET_PORTFOLIO_FAULT_DETAILS_SUCCESS,
                { data: data }
            ));
        } else {
            dispatch(
            createActionObject(
                actionTypes.GET_PORTFOLIO_FAULT_DETAILS_FAILURE,
                { data: null }
            ));
        }
        })
        .catch((error) => {
        dispatch(
            createActionObject(
            actionTypes.GET_PORTFOLIO_FAULT_DETAILS_FAILURE,
            { error: error.message || "An error occurred while fetching portfolio details." }
            )
        );
    });
};

export const callPortfolioFaultData = (payload) => (dispatch) =>
  getAjaxFunc(
    actionTypes.FETCH_PORTFOLIO_FAULT_REQUEST,
    "",
    actionTypes.FETCH_PORTFOLIO_FAULT_FAILURE,
    "",
    dispatch
  )(() =>
    api.getPortfolioFault(payload).then(({ data, status }) => {
      if (status === 200 && data) {
        try {
          // Convert = to : and quote keys/values appropriately
          const formattedData = data
            .replace(/=/g, ':')
            .replace(/([{,]\s*)(\w+)(\s*:\s*["'{}[\w])/g, '$1"$2"$3')
            .replace(/([{,]\s*".+?"\s*:\s*)([^"{}\[\],\s].*?)([,\s}])/g, (match, p1, p2, p3) => {
              return /^\d+$/.test(p2)
                ? `${p1}${p2}${p3}`
                : `${p1}"${p2.replace(/"/g, '\\"')}"${p3}`;
            });

          const jsonData = JSON.parse(formattedData);
          const jsonArray = jsonData.jsonArray || [];
          const jsonArrayCount = jsonData.jsonArrayCount || [];

          const portfolioFaultData = [];
          jsonArray.forEach(entry => {
            const timestamp = entry.timestamp;
            if (entry.stations) {
              entry.stations.forEach(station => {
                portfolioFaultData.push({
                  timestamp,
                  faultTm: station.faultTm,
                  stationId: station.stationId,
                  deviceNames: station.deviceNames,
                  deviceModels: station.deviceModels,
                  deviceModelIds: station.deviceModelIds,
                  deviceBrands: station.deviceBrands,
                  deviceStatus: station.deviceStatus,
                  errorCodes: station.errorCodes,
                  faultLevels: station.faultLevels,
                  faultTypes: station.faultTypes,
                });
              });
            }
          });

          dispatch({
            type: actionTypes.FETCH_PORTFOLIO_FAULT_SUCCESS,
            portfolioFaultData,
            portfolioFaultDataCount: jsonArrayCount,
          });
        } catch (error) {
          console.error("Error parsing or transforming portfolio fault data:", error);
          dispatch({
            type: actionTypes.FETCH_PORTFOLIO_FAULT_FAILURE,
            message: 'Parsing failed: ' + error.message,
          });
        }
      }
    })
  )();

  // version2
  export const callPortfolioFaultLogData = (payload) => (dispatch) => {
    
    dispatch({ type: actionTypes.FETCH_PORTFOLIO_FAULT_LOG_REQUEST });
  
    api.getPortfolioFaultLog(payload)
      .then(({ data, status }) => {
        if (status === 200 && data) {
          try {
            const jsonArray = JSON.parse(data); // parse the JSON string into array
  
            const portfolioFaultLog = jsonArray.map(entry => ({
              timestamp: entry.Tm,
              stationId: entry.stationId,
              deviceMaps: entry.deviceMaps.map(device => ({
                deviceModel: device.deviceModel,
                deviceName: device.deviceName,
                deviceBrand: device.deviceBrand,
                deviceStatus: device.deviceStatus,
                errorCode: device.errorCode,
                faultType: device.faultType
              }))
            }));
  
            dispatch({
              type: actionTypes.FETCH_PORTFOLIO_FAULT_LOG_SUCCESS,
              portfolioFaultLog
            });
          } catch (error) {
            console.error("Error parsing JSON:", error);
            dispatch({
              type: actionTypes.FETCH_PORTFOLIO_FAULT_LOG_FAILURE,
              error: "Failed to parse API data: " + error.message
            });
          }
        } else {
          dispatch({
            type: actionTypes.FETCH_PORTFOLIO_FAULT_LOG_FAILURE,
            error: "API returned non-200 or empty data"
          });
        }
      })
      .catch((error) => {
        console.error("API call failed:", error);
        dispatch({
          type: actionTypes.FETCH_PORTFOLIO_FAULT_LOG_FAILURE,
          error: "API request failed: " + error.message
        });
      });
  };
  
  export const resetPortfolioFaultData = () => (dispatch) => {
    dispatch({ type: actionTypes.RESET_PORTFOLIO_FAULT_DATA });
  };
  
  export const resetPortfolioFaultLog = () => (dispatch) => {
    dispatch({ type: actionTypes.RESET_PORTFOLIO_FAULT_LOG });
  };